import { render, staticRenderFns } from "./RadioGroup.vue?vue&type=template&id=cd63fb72&scoped=true&"
import script from "./RadioGroup.vue?vue&type=script&lang=js&"
export * from "./RadioGroup.vue?vue&type=script&lang=js&"
import style0 from "./RadioGroup.vue?vue&type=style&index=0&id=cd63fb72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd63fb72",
  null
  
)

export default component.exports